/**
 * Dependencies.
 */
import de from './de';
import en from './en';
import es from './es';
import it from './it';
import pt from './pt';

/**
 * Export translations.
 */
export default {
  'de-DE': { SERVICE_POINT: de },
  'en-US': { SERVICE_POINT: en },
  'es-ES': { SERVICE_POINT: es },
  'it-IT': { SERVICE_POINT: it },
  'pt-PT': { SERVICE_POINT: pt }
};
